export default {
  service: {
    title: 'Mes services',
    subtitle: 'Vous pouvez accéder à toutes vos plateformes',
    otherAvailable: 'Tous les services disponible',
    access: 'Accéder à ce service',
    enable: 'Activer ce service',
    moreService: 'Voir tous mes services',
    dialogContent: {
      content: 'Pour accéder à ce service vous devez contacter l\'équipe support au 01 23 45 67 89 ou par mail à Loremipsum{\'@\'}dolor.sit',
      subtitle: 'Accéder à un nouveau service'
    },
    legalMentions: 'Mentions Légales',
    eula: 'CGU',
    endUserLicenseAgreement: 'Conditions Générales d\'utilisation',
    applicationSettings: 'Configuration de l\'application'
  },
  support: {
    title: 'Support',
    contact: 'Contact',
    phone: 'Numéro de téléphone',
    mail: 'Adresse mail',
    links: 'Liens utiles',
    webSite: 'Notre site internet',
    headOffice: 'Siège social'
  }
}
